/**
 * Maps an array of data items to a template.
 * @param {string[]} results
 * @param {jQuery} $itemTemplate
 * @return {Element[]}
 */
const mapTypeToTemplate = (results, $itemTemplate) => (
    results
        .map(type => {
            const $item = $itemTemplate.clone();
            $item.find('input').attr('id', type);
            $item.find('input').attr('name', type);
            $item.find('input').val(type);
            $item.find('label').attr('for', type);
            $item.find('label').text(type);

            return $item.get(0);
        })
);

export default mapTypeToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/mapTypeToTemplate.js